export function Auth() {

    window.location.href = process.env.REACT_APP_BASE_URL + '/sso/auth';

    return <></>;
}